module.exports = __webpack_public_path__ + "img/1920_island_intro_img4.58e1d3ab.png";